namespace ekh {

    export class NewsLetterSignUpFullForm {
        public allowUnsubscribe: boolean;
        public showExtended:boolean = false;
        public gaEventIsSent:boolean = false;
        public salutationOptions: () => string;

        public email: null|string;
        public firstName: null|string;
        public lastName: null|string;
        public title: string;
        protected signUpReason: string = 'Newsletter Signup Header';

        public subscribePrimaryButtonLabel: string = 'NEWSLETTERSIGNUPNOW';

        constructor(
            protected resourceService: Core.ResourceService,
            protected $location: ng.ILocationService,
            protected analytics: any,
            protected $scope: ng.IScope,
            protected $timeout: ng.ITimeoutService
        ) {
            this.salutationOptions = resourceService.getDeferred('NEWSLETTERSIGNUPSALUTATIONOPTIONS');
            this._initData();
        }

        protected _initData() {
            this.email = null;
            this.firstName = null;
            this.lastName = null;
            this.title = '';
        }

        public onEmailFocused() {
            this.showExtended = true;
            if (!this.gaEventIsSent && TRPCONFIG.Domain.TrackNewsletterSignup) {
                const page = this.$location.path();
                this.analytics.trackEvent({
                    category: 'newsletterSignup',
                    action: 'emailInputFocused',
                    label: page,
                    dimension9: 'newsletterSignup'
                });
                this.gaEventIsSent = true;
            }
        }

        protected _getLanguageCode() {
            let langCode;
            try {
                langCode = TRPCONFIG.Domain.CultureCode.split('-')[0];
            } catch(err) {
                langCode = '';
            }
            return langCode;
        };

        protected _getData() {
            return {
                Email: this.email,
                FirstName: this.firstName,
                LastName: this.lastName,
                LanguageCode: this._getLanguageCode(),
                ContextTag: 'Source:Website-Newsletter',
                Source: 'TravelRepublic',
                SignupReason: this.signUpReason,
                Title: this.title
            };
        }

        protected _getGaTrackData() {
            const page = this.$location.path();
            return {
                category: 'newsletterSignup',
                action: 'signedUp',
                label: page,
                dimension9: 'newsletterSignup'
            };
        }

        public getSubscribePrimaryButtonLabel() {
            return this.resourceService.get(this.subscribePrimaryButtonLabel);
        }

        public submit() {
            if (!this.showExtended) {
                this.showExtended = true;
                return false;
            }
            const data = this._getData();
            this.$scope.formState.resetSubmitResult();
            return this.$scope.formState.submit(data)
                .then(() => {
                    if (TRPCONFIG.Domain.TrackNewsletterSignup) {
                        this.analytics.trackEvent(this._getGaTrackData());
                    }
                    this.$timeout(() => {
                        this.$scope.formState.resetFormState();
                        this.showExtended = false;
                        this._initData();
                    }, 5000);
                });
        };
    }

    angular
        .module('ekh')
        .directive('newsletterSignUpFullForm', function(authService) {
            return {
                restrict: 'E',
                replace: true,
                templateUrl: 'partials/home/directivetemplate?type=newslettersignupfullform',
                controllerAs: 'nsu',
                bindToController: {
                    allowUnsubscribe: '='
                },
                scope: {
                },
                link: ($scope) => {
                    $scope.formState.setSubmitFn(data => {
                        return authService
                            .registerForNewsletter(data);
                    });
                },
                controller: NewsLetterSignUpFullForm
            };
        });
}
